var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"请使用手机扫码答题","visible":_vm.dialogVisible,"modal-append-to-body":false,"close-on-click-modal":false,"close-on-press-escape":false,"width":"30%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"dialog-content"},[_c('vue-qr',{ref:"qr",attrs:{"text":_vm.qr,"size":400}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }